export const TEMPLATES = 'payments/mails/all'
export const TEMPLATE = 'payments/mails/edit'
export const UPSERT_TEMPLATE = 'payments/mails/upsert'
export const CONFIGURE = 'payment/mails/configure'
